import { ITradingPositionReport, ITradingPositionReportPosQtys } from "@pulse-ui/codegen/generated_ts/position_management";
import { IAGPositionUpdateDataRow } from "../../../AlgoTable.types";
import { getParties } from "../helpers";
import { v4 as uuidv4 } from "uuid";

const posQtyToRow = (pq: ITradingPositionReportPosQtys) => {
    return {
        row_id: uuidv4(),
        pos_type: pq.pos_type?.toString() ?? "-",
        long_qty: pq.long_qty?.toString() ?? "-",
        short_qty: pq.short_qty?.toString() ?? "-",
        unrealized_pnl: pq?.unrealized_pnl?.toString() ?? "-",
    };
}

export const mapPositionUpdate = (rpt: ITradingPositionReport): IAGPositionUpdateDataRow => {
    const partiesGroup = rpt?.parties ? getParties(rpt.parties) : null;
    let totalLong = 0, totalShort = 0;
    const posQtys = (rpt?.pos_qtys ?? []).map(posQtyToRow);
    for (const pq of rpt?.pos_qtys ?? []) {
        totalLong += parseFloat(pq.long_qty?.toString() ?? "0");
        totalShort += parseFloat(pq.short_qty?.toString() ?? "0");
    }
    return {
        detail_expander: "",
        row_id: uuidv4(),
        clearing_date: rpt?.clearing_date ?? "-",
        parties: rpt?.parties?.toString() ?? "-",
        symbol: rpt?.symbol?.toString() ?? "-",
        contract_size: rpt?.contract_size?.toString() ?? "-",
        total_short: rpt?.parties?.length ? totalShort.toString() : "-",
        total_long: rpt?.parties?.length ? totalLong.toString() : "-",
        pos_qtys: posQtys,
        pos_event_type: rpt?.pos_event_type?.toString() ?? "-",
        updated: rpt?.updated ?? "-",
        executing_firm: partiesGroup?.executing_firm?.party_id ?? "-",
        exchange: partiesGroup?.exchange?.party_id ?? "-",
        customer_account: partiesGroup?.customer_account?.party_id ?? "-",
        intermediary: partiesGroup?.intermediary?.party_id ?? "-",
        account_wallet: partiesGroup?.account_wallet?.party_id ?? "-",
        blockchain_wallet: partiesGroup?.blockchain_wallet?.party_id ?? "-",
    };
}